export default "__VITE_ASSET__MKIL2mR2__"